export default "__VITE_ASSET__B89wQwwH__"